<template>
  <div>
    <h1>{{ $t("vehicleList.title") }}</h1>

    <vehicle-list />
  </div>
</template>

<script>
import VehicleList from "../../components/Settings/Vehicles/VehicleList.vue";

export default {
  name: "SettingsVehiclesView",
  components: { VehicleList }
};
</script>

<style scoped></style>
